import React from 'react'
import { useStateMachine } from 'little-state-machine'
import { Rxios } from 'rxios'
import axios from 'axios'
import { ApplicationStore } from '../../states'

import {
  removeAuthToken,
  removeAuth2FA,
  removeUserName,
  removeClientId,
  removeClientSecret,
  removeUserIdSf,
  removeUserRole,
  removeIsRefresh,
  removeIsRefreshTransactions,
  updateAuthToken,
  updateAuth2FA,
  updateUserName,
  updateClientId,
  updateClientSecret,
  updateUserIdSf,
  updateUserRole,
  updateIsRefresh,
  updateIsRefreshTransactions,
} from '../../actions'
import { restAxios, rxios } from '../../utils/NetUtils'
import { AppStateContextType } from './AppStateContextType'
import { setAppContextInstance } from './appContextInstance'

const errorInitFunction = () => {
  throw new Error(`AppStateContext not initialized`)
}

export const AppStateContext = React.createContext<AppStateContextType>({
  getAuthToken: errorInitFunction,
  getAuth2FA: errorInitFunction,
  getUserName: errorInitFunction,
  getClientId: errorInitFunction,
  getClientSecret: errorInitFunction,
  getUserIdSf: errorInitFunction,
  getUserRole: errorInitFunction,
  getIsRefresh: errorInitFunction,
  getIsRefreshTransactions: errorInitFunction,
  setAuthTokenInStore: errorInitFunction,
  removeAuthTokenFromStore: errorInitFunction,
  setAuth2FAInStore: errorInitFunction,
  removeAuth2FAFromStore: errorInitFunction,
  setUserNameInStore: errorInitFunction,
  removeUserNameFromStore: errorInitFunction,
  setClientIdInStore: errorInitFunction,
  removeClientIdFromStore: errorInitFunction,
  setClientSecretInStore: errorInitFunction,
  removeClientSecretFromStore: errorInitFunction,
  setUserIdSfInStore: errorInitFunction,
  removeUserIdSfFromStore: errorInitFunction,
  setUserRoleInStore: errorInitFunction,
  removeUserRoleFromStore: errorInitFunction,
  setIsRefreshInStore: errorInitFunction,
  removeIsRefreshFromStore: errorInitFunction,
  setIsRefreshTransactionsInStore: errorInitFunction,
  removeIsRefreshTransactionsFromStore: errorInitFunction,
  rxiosClient: rxios,
  rxiosAuthorized: rxios,
  rxios2FA: rxios,
  axiosAuthorized: restAxios,
  isLoggedIn: false,
})

export const AppStateProvider: React.FC = ({ children }) => {
  // eslint-disable-next-line @typescript-eslint/ban-ts-comment
  // @ts-ignore
  const { state } = useStateMachine<ApplicationStore>()

  // eslint-disable-next-line @typescript-eslint/ban-ts-comment
  // @ts-ignore
  const setAuthTokenInStore = useStateMachine<ApplicationStore>({ updateAuthToken }).actions.updateAuthToken as (
    token: string | undefined,
  ) => void
  // eslint-disable-next-line @typescript-eslint/ban-ts-comment
  // @ts-ignore
  const removeAuthTokenFromStore = useStateMachine<ApplicationStore>({ removeAuthToken }).actions
    .removeAuthToken as () => void

  // eslint-disable-next-line @typescript-eslint/ban-ts-comment
  // @ts-ignore
  const setAuth2FAInStore = useStateMachine<ApplicationStore>({ updateAuth2FA }).actions.updateAuth2FA as (
    twoFA: string | undefined,
  ) => void
  // eslint-disable-next-line @typescript-eslint/ban-ts-comment
  // @ts-ignore
  const removeAuth2FAFromStore = useStateMachine<ApplicationStore>({ removeAuth2FA }).actions
    .removeAuth2FA as () => void

  // eslint-disable-next-line @typescript-eslint/ban-ts-comment
  // @ts-ignore
  const setUserNameInStore = useStateMachine<ApplicationStore>({ updateUserName }).actions.updateUserName as (
    userName: string | undefined,
  ) => void
  // eslint-disable-next-line @typescript-eslint/ban-ts-comment
  // @ts-ignore
  const removeUserNameFromStore = useStateMachine<ApplicationStore>({ removeUserName }).actions
    .removeUserName as () => void

  // eslint-disable-next-line @typescript-eslint/ban-ts-comment
  // @ts-ignore
  const setClientIdInStore = useStateMachine<ApplicationStore>({ updateClientId }).actions.updateClientId as (
    clientId: string | undefined,
  ) => void
  // eslint-disable-next-line @typescript-eslint/ban-ts-comment
  // @ts-ignore
  const removeClientIdFromStore = useStateMachine<ApplicationStore>({ removeClientId }).actions
    .removeClientId as () => void

  // eslint-disable-next-line @typescript-eslint/ban-ts-comment
  // @ts-ignore
  const setClientSecretInStore = useStateMachine<ApplicationStore>({ updateClientSecret }).actions
    .updateClientSecret as (clientSecret: string | undefined) => void
  // eslint-disable-next-line @typescript-eslint/ban-ts-comment
  // @ts-ignore
  const removeClientSecretFromStore = useStateMachine<ApplicationStore>({ removeClientSecret }).actions
    .removeClientSecret as () => void

  // eslint-disable-next-line @typescript-eslint/ban-ts-comment
  // @ts-ignore
  const setUserIdSfInStore = useStateMachine<ApplicationStore>({ updateUserIdSf }).actions.updateUserIdSf as (
    userIdSf: string | undefined,
  ) => void
  // eslint-disable-next-line @typescript-eslint/ban-ts-comment
  // @ts-ignore
  const removeUserIdSfFromStore = useStateMachine<ApplicationStore>({ removeUserIdSf }).actions
    .removeUserIdSf as () => void

  // eslint-disable-next-line @typescript-eslint/ban-ts-comment
  // @ts-ignore
  const setUserRoleInStore = useStateMachine<ApplicationStore>({ updateUserRole }).actions.updateUserRole as (
    userRole: string | undefined,
  ) => void
  // eslint-disable-next-line @typescript-eslint/ban-ts-comment
  // @ts-ignore
  const removeUserRoleFromStore = useStateMachine<ApplicationStore>({ removeUserRole }).actions
    .removeUserRole as () => void

  // eslint-disable-next-line @typescript-eslint/ban-ts-comment
  // @ts-ignore
  const setIsRefreshInStore = useStateMachine<ApplicationStore>({ updateIsRefresh }).actions.updateIsRefresh as (
    isRefresh: boolean | undefined,
  ) => void
  // eslint-disable-next-line @typescript-eslint/ban-ts-comment
  // @ts-ignore
  const removeIsRefreshFromStore = useStateMachine<ApplicationStore>({ removeIsRefresh }).actions
    .removeIsRefreshTransactions as () => void

  // eslint-disable-next-line @typescript-eslint/ban-ts-comment
  // @ts-ignore
  const setIsRefreshTransactionsInStore = useStateMachine<ApplicationStore>({ updateIsRefreshTransactions }).actions
    .updateIsRefreshTransactions as (isRefreshTransactions: boolean | undefined) => void
  // eslint-disable-next-line @typescript-eslint/ban-ts-comment
  // @ts-ignore
  const removeIsRefreshTransactionsFromStore = useStateMachine<ApplicationStore>({ removeIsRefreshTransactions })
    .actions.removeIsRefreshTransactions as () => void

  // eslint-disable-next-line @typescript-eslint/ban-ts-comment
  // @ts-ignore
  const getAuthToken = () => state.authToken as string
  // eslint-disable-next-line @typescript-eslint/ban-ts-comment
  // @ts-ignore
  const getAuth2FA = () => state.auth2FA as string
  // eslint-disable-next-line @typescript-eslint/ban-ts-comment
  // @ts-ignore
  const getUserName = () => state.userName as string
  // eslint-disable-next-line @typescript-eslint/ban-ts-comment
  // @ts-ignore
  const getClientId = () => state.clientId as string
  // eslint-disable-next-line @typescript-eslint/ban-ts-comment
  // @ts-ignore
  const getClientSecret = () => state.clientSecret as string
  // eslint-disable-next-line @typescript-eslint/ban-ts-comment
  // @ts-ignore
  const getUserIdSf = () => state.userIdSf as string
  // eslint-disable-next-line @typescript-eslint/ban-ts-comment
  // @ts-ignore
  const getUserRole = () => state.userRole as string
  // eslint-disable-next-line @typescript-eslint/ban-ts-comment
  // @ts-ignore
  const getIsRefresh = () => state.isRefresh as boolean
  // eslint-disable-next-line @typescript-eslint/ban-ts-comment
  // @ts-ignore
  const getIsRefreshTransactions = () => state.isRefreshTransactions as boolean

  const rxiosClient = new Rxios({
    baseURL: `${process.env.REACT_APP_REST_API_URL}/`,
  })

  const rxiosAuthorized = new Rxios({
    baseURL: `${process.env.REACT_APP_REST_API_URL}/`,
    headers: {
      Authorization: `Bearer ${getAuthToken()}`,
    },
  })

  const rxios2FA = new Rxios({
    baseURL: `${process.env.REACT_APP_REST_API_URL}/`,
    headers: {
      Authorization: `Bearer ${getAuth2FA()}`,
    },
  })

  const axiosAuthorized = axios.create({
    baseURL: `${process.env.REACT_APP_REST_API_URL}/`,
    headers: {
      Authorization: `Bearer ${getAuthToken() || getAuth2FA()}`,
    },
  })

  // eslint-disable-next-line @typescript-eslint/ban-ts-comment
  // @ts-ignore
  const isLoggedIn = (!!state.authToken && state.authToken.length >= 5) as boolean

  const value = {
    getAuthToken,
    getAuth2FA,
    getUserName,
    getClientId,
    getClientSecret,
    getUserIdSf,
    getUserRole,
    getIsRefresh,
    getIsRefreshTransactions,
    setAuthTokenInStore,
    removeAuthTokenFromStore,
    setAuth2FAInStore,
    removeAuth2FAFromStore,
    setUserNameInStore,
    removeUserNameFromStore,
    setClientIdInStore,
    removeClientIdFromStore,
    setClientSecretInStore,
    removeClientSecretFromStore,
    setUserIdSfInStore,
    removeUserIdSfFromStore,
    setUserRoleInStore,
    removeUserRoleFromStore,
    setIsRefreshInStore,
    removeIsRefreshFromStore,
    setIsRefreshTransactionsInStore,
    removeIsRefreshTransactionsFromStore,
    rxiosClient,
    rxiosAuthorized,
    rxios2FA,
    axiosAuthorized,
    isLoggedIn,
  }

  setAppContextInstance(value)

  return <AppStateContext.Provider value={value}>{children}</AppStateContext.Provider>
}
